var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "pageFrom",
                      attrs: {
                        inline: "",
                        size: "small",
                        model: _vm.pageFrom,
                        "label-position": "right",
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类：" } },
                        [
                          _c("el-cascader", {
                            staticClass: "selWidth",
                            attrs: {
                              options: _vm.merCateList,
                              props: _vm.props,
                              clearable: "",
                              size: "small",
                            },
                            on: { change: _vm.search },
                            model: {
                              value: _vm.pageFrom.cateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.pageFrom, "cateId", $$v)
                              },
                              expression: "pageFrom.cateId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入商品名称",
                              clearable: "",
                            },
                            on: { change: _vm.search },
                            model: {
                              value: _vm.pageFrom.skuName,
                              callback: function ($$v) {
                                _vm.$set(_vm.pageFrom, "skuName", $$v)
                              },
                              expression: "pageFrom.skuName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "SKU编码：" } },
                        [
                          _c("el-input", {
                            staticClass: "selWidth",
                            attrs: {
                              placeholder: "请输入SKU编码",
                              clearable: "",
                            },
                            on: { change: _vm.search },
                            model: {
                              value: _vm.pageFrom.skuCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.pageFrom, "skuCode", $$v)
                              },
                              expression: "pageFrom.skuCode",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "平台状态：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.platformStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "platformStatus", $$v)
                                },
                                expression: "pageFrom.platformStatus",
                              },
                            },
                            _vm._l(
                              _vm.platformStatusEnum,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "请选择",
                                filterable: "",
                                remote: "",
                                "remote-method": _vm.brandRemoteMethod,
                                size: "small",
                                clearable: "",
                              },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "brandId", $$v)
                                },
                                expression: "pageFrom.brandId",
                              },
                            },
                            _vm._l(_vm.brandList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.brandName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.ljcType && _vm.ljcType != 5
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "商品供应商：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    placeholder: "请选择",
                                    filterable: "",
                                    remote: "",
                                    "remote-method": _vm.supplierRemoteMethod,
                                    clearable: "",
                                    size: "small",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.supplierId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "supplierId", $$v)
                                    },
                                    expression: "pageFrom.supplierId",
                                  },
                                },
                                _vm._l(_vm.suppliers, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.supplierName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商家状态：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth",
                              attrs: { placeholder: "请选择", clearable: "" },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.merchantStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "merchantStatus", $$v)
                                },
                                expression: "pageFrom.merchantStatus",
                              },
                            },
                            _vm._l(
                              _vm.supperStatusEnum,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "action-buttons-container" }, [
                    _c("div", { staticClass: "button-row" }, [
                      _c("div", { staticClass: "button-group" }, [
                        _c("div", { staticClass: "group-title" }, [
                          _vm._v("操作管理"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "button-container" },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:delete",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:delete']",
                                  },
                                ],
                                attrs: {
                                  type: "danger",
                                  plain: "",
                                  icon: "el-icon-delete",
                                  size: "small",
                                },
                                on: { click: _vm.deleteBatch },
                              },
                              [
                                _vm._v(
                                  "\n                  批量移除\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:search",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:search']",
                                  },
                                ],
                                attrs: {
                                  type: "info",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.search },
                              },
                              [
                                _vm._v(
                                  "\n                  搜索\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:add",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:add']",
                                  },
                                ],
                                attrs: {
                                  type: "success",
                                  icon: "el-icon-plus",
                                  size: "small",
                                },
                                on: { click: _vm.addGoods },
                              },
                              [
                                _vm._v(
                                  "\n                  添加商品\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:sync",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:sync']",
                                  },
                                ],
                                attrs: {
                                  type: "success",
                                  icon: "el-icon-plus",
                                  size: "small",
                                },
                                on: { click: _vm.syncRenshouProduct },
                              },
                              [_vm._v("同步仁寿商品")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:synclog",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:synclog']",
                                  },
                                ],
                                attrs: {
                                  type: "success",
                                  icon: "el-icon-document-copy",
                                  size: "small",
                                },
                                on: { click: _vm.viewRenshouSyncLog },
                              },
                              [_vm._v("仁寿同步日志")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "button-group" }, [
                        _c("div", { staticClass: "group-title" }, [
                          _vm._v("数据导入导出"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "button-container" },
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:export",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:export']",
                                  },
                                ],
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-download",
                                  size: "small",
                                },
                                on: { click: _vm.exportCustomerSku },
                              },
                              [
                                _vm._v(
                                  "\n                  导出结果\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:lowsku",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:lowsku']",
                                  },
                                ],
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-download",
                                  size: "small",
                                },
                                on: { click: _vm.exportLowestPriceSku },
                              },
                              [
                                _vm._v(
                                  "\n                  最低价SKU\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:import",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:import']",
                                  },
                                ],
                                attrs: {
                                  type: "success",
                                  icon: "el-icon-document-copy",
                                  size: "small",
                                },
                                on: { click: _vm.exportTemp },
                              },
                              [
                                _vm._v(
                                  "\n                  导出模板\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.homeType
                              ? _c(
                                  "ProgressUploadExcel",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: [
                                          "admin:mini:program:customer:product:update:supplyprice",
                                        ],
                                        expression:
                                          "['admin:mini:program:customer:product:update:supplyprice']",
                                      },
                                    ],
                                    attrs: {
                                      beforeUpload: function (file) {
                                        return _vm.beforeUpload(
                                          file,
                                          "updatePriceApi"
                                        )
                                      },
                                      progressTitle: "导入更新供货价",
                                      size: "small",
                                    },
                                  },
                                  [[_vm._v("更新供货价")]],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "ProgressUploadExcel",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:update",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:update']",
                                  },
                                ],
                                attrs: {
                                  beforeUpload: function (file) {
                                    return _vm.beforeUpload(
                                      file,
                                      "updateStatusApi"
                                    )
                                  },
                                  progressTitle: "导入更新上下架",
                                  size: "small",
                                },
                              },
                              [[_vm._v("更新上下架")]],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "ProgressUploadExcel",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:import:commodity",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:import:commodity']",
                                  },
                                ],
                                attrs: {
                                  beforeUpload: function (file) {
                                    return _vm.beforeUpload(
                                      file,
                                      "updateCustomerSkuApi"
                                    )
                                  },
                                  progressTitle: "导入更新商品",
                                  canRetry: false,
                                  size: "small",
                                },
                              },
                              [[_vm._v("更新商品")]],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "ProgressUploadExcel",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:mini:program:customer:product:import:authorization",
                                    ],
                                    expression:
                                      "['admin:mini:program:customer:product:import:authorization']",
                                  },
                                ],
                                attrs: {
                                  beforeUpload: function (file) {
                                    return _vm.beforeUpload(
                                      file,
                                      "customerSkuApi"
                                    )
                                  },
                                  progressTitle: "导入新商品授权",
                                  size: "small",
                                },
                              },
                              [[_vm._v("新商品授权")]],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "max-height": "600",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuId", label: "SKU ID", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuCode", label: "SKU编码", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuName", label: "名称", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "platformStatusDesc",
                  label: "平台状态",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌", "min-width": "80" },
              }),
              _vm._v(" "),
              !_vm.homeType
                ? _c("el-table-column", {
                    attrs: {
                      prop: "supplierName",
                      label: "供应商",
                      "min-width": "80",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailPrice",
                  label: "零售价",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _vm.ljcType && _vm.ljcType != 5
                ? _c("el-table-column", {
                    attrs: {
                      prop: "costPrice",
                      label: "成本价",
                      "min-width": "80",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyPrice",
                  label: "供货价",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "mini" },
                          on: {
                            input: function ($event) {
                              return _vm.changePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.supplyPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "supplyPrice", $$v)
                            },
                            expression: "scope.row.supplyPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "distributionPrice",
                  label: "售价",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "mini" },
                          on: {
                            input: function ($event) {
                              return _vm.changePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.distributionPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "distributionPrice", $$v)
                            },
                            expression: "scope.row.distributionPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "newcomerPrice",
                  label: "新人价",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "mini" },
                          on: {
                            input: function ($event) {
                              return _vm.changePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.newcomerPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "newcomerPrice", $$v)
                            },
                            expression: "scope.row.newcomerPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "virtualSales", "min-width": "130" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input-number", {
                            attrs: {
                              min: 0,
                              max: 9999999,
                              precision: 0,
                              "controls-position": "right",
                              size: "mini",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeVirtualSales(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.virtualSales,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "virtualSales", $$v)
                              },
                              expression: "scope.row.virtualSales",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c(
                      "span",
                      { staticClass: "virtual-sales-header" },
                      [
                        _c("span", [_vm._v("虚拟销量")]),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "此销量为自定义销量，非真实销量",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-question virtual-sales-tip",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "商家状态", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "上架",
                            "inactive-text": "下架",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeStatus(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "50", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: [
                                  "admin:mini:program:customer:product:remove",
                                ],
                                expression:
                                  "['admin:mini:program:customer:product:remove']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteRecode(scope.row)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "10px 0" } },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AddGoodsVue", {
        ref: "AddGoodsVueRef",
        attrs: { customerId: _vm.customerId },
        on: { refresh: _vm.getList },
      }),
      _vm._v(" "),
      _c("DeleteCouponVue", {
        ref: "DeleteCouponVueRef",
        on: { refresh: _vm.getList },
      }),
      _vm._v(" "),
      _c("RenshouSyncLogVue", { ref: "RenshouSyncLogRef" }),
      _vm._v(" "),
      _c("SyncConfirmVue", { ref: "SyncConfirmRef" }),
      _vm._v(" "),
      _c("ProgressBar", {
        attrs: {
          visible: _vm.exportProgress.visible,
          title: _vm.exportProgress.title,
          percentage: _vm.exportProgress.percentage,
          statusText: _vm.exportProgress.statusText,
          isError: _vm.exportProgress.isError,
          isSuccess: _vm.exportProgress.isSuccess,
          canCancel: _vm.exportProgress.canCancel,
          timeRemaining: _vm.exportProgress.estimatedTime,
          fileSize: _vm.exportProgress.fileSize,
        },
        on: {
          cancel: _vm.handleExportCancel,
          retry: _vm.handleExportRetry,
          complete: _vm.handleExportComplete,
          close: _vm.handleExportComplete,
        },
      }),
      _vm._v(" "),
      _c("ProgressBar", {
        attrs: {
          visible: _vm.importProgress.visible,
          title: _vm.importProgress.title,
          percentage: _vm.importProgress.percentage,
          statusText: _vm.importProgress.statusText,
          isError: _vm.importProgress.isError,
          isSuccess: _vm.importProgress.isSuccess,
          canCancel: false,
          canRetry: false,
        },
        on: {
          complete: _vm.handleImportProgressClose,
          close: _vm.handleImportProgressClose,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }